/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsPaperclipVertical: {
  name: 'paperclip-vertical';
  data: string;
} = {
  name: 'paperclip-vertical',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 6.5a2.5 2.5 0 0 1 5 0V16a1 1 0 0 1-2 0V7a1 1 0 1 0-2 0v9a3 3 0 1 0 6 0V6.5a4.5 4.5 0 1 0-9 0V16a6 6 0 0 0 12 0V6a1 1 0 1 0-2 0v10a4 4 0 0 1-8 0V6.5Z" fill="currentColor"/></svg>`,
};
